import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import { Filters } from '../filters/Filters';
import { SystemCard } from '../systemCard/SystemCard';
// import Pagination from '../../shared/pagination/Pagination';
import SortDropdown from '../../../molecules/category/sortDropdown/SortDropdown';
import { Filter } from '../../../../../static/icons/filter';
import { FiltersModal } from '../filters/filtersModal/FiltersModal';
import CompareBottomBar from '../compareBottomBar/CompareBottomBar';
import SystemListCta from '../systemListCta/SystemListCta';

export const SystemList = ({
  section,
  filter = true,
  showCompareBtn = true,
  showRelatedCategories = false,
  showSubCategories = false,
  showCta = false,
  locale,
  trackOutboundLink,
  t,
}) => {
  // const itemsPerPage = 12;
  // const totalPages = Math.ceil(section.componentData.length / itemsPerPage);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [selectedSort, setSelectedSort] = useState(1);
  // const [selectedFilters, setSelectedFilters] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [systemList, setSystemList] = useState([]);
  // const [compareSystems, setCompareSystems] = useState([]);

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      setIsFilterModalOpen(false);
    }
  };

  useEffect(() => {
    if (isFilterModalOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('click', handleBackdropClick);
    } else {
      document.body.style.overflow = '';
      document.removeEventListener('click', handleBackdropClick);
    }
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('click', handleBackdropClick);
    };
  }, [isFilterModalOpen]);

  const {
    systems,
    noResults,
    systemPageUrl,
    relatedCategories,
    subCategories,
    compare,
    filters,
    activeFilters,
    sorting,
    handleCompare,
    handleFilterChange,
    handleEmptyFilterItem,
    handleSortChange,
    emptyFilter,
    categoryName,
    category,
    categoryId,
    // compareSystemsPageUrl,
    compareSystemsStaticPageUrl,
    showCompare = true,
    type,
    handleAddComparison,
    ctaBanner,
  } = section.componentData;

  useEffect(() => {
    let list = systems;
    if (systems?.length > 6 && showCta) {
      // Add one object at the sixth position
      list = [
        ...systems.slice(0, 6),
        {
          type: 'CTA',
          id: 'ctaGuide',
          data: ctaBanner,
        },
        ...systems.slice(6),
      ];
    } else {
      list = systems;
    }

    setSystemList(list);
  }, [systems]);

  const sortItemsFunction = (itemA, itemB) => {
    const language = locale?.split('_')?.[0];

    if (language?.length === 2) {
      return Intl.Collator(language).compare(itemA.name, itemB.name);
    }

    return itemA.name.localeCompare(itemB.name);
  };

  const labelFunction = (option, optionName, optionLocaleString, category) => {
    const fallbackString = t([
      `prodFunc.${category}.${option}`,
      `branch.${option}`,
      `prodFunc.common.${option}`,
    ]);

    const prettyName =
      optionName ||
      (optionLocaleString ? t(optionLocaleString) : fallbackString || option);

    return { option, name: prettyName };
  };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  // };

  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = startIndex + itemsPerPage;

  // const onSelectSort = (sortId) => {
  //   setSelectedSort(sortId);
  // };

  // const handleFilterChange = (filterId, selectedOption) => {
  //   setSelectedFilters({ ...selectedFilters, [filterId]: selectedOption });
  // };

  // const handleClearFilters = () => {
  //   setSelectedFilters({});
  // };

  // const onSystemCompare = (name) => {
  //   if (compareSystems.find((el) => el === name) !== undefined) {
  //     const newCompare = compareSystems.filter((el) => el !== name);
  //     setCompareSystems(newCompare);
  //     return;
  //   }
  //   if (compareSystems.length === 2) {
  //     return;
  //   }
  //   const newCompare = [...compareSystems, name];
  //   setCompareSystems(newCompare);
  // };

  return (
    <div className="flex w-full flex-col flex-1 gap-10 px-8 lg:mx-auto my-5 max-w-7xl">
      <div className="flex flex-col md:flex-row flex-1 justify-between py-4 gap-5">
        {filter && (
          <Stack className="max-w-64 w-full pt-10 max-md:hidden">
            <Filters
              filters={filters}
              selectedFilters={activeFilters}
              onFilterChange={handleFilterChange}
              handleClearFilters={emptyFilter}
              category={category}
              labelFunction={labelFunction}
              sortFunction={sortItemsFunction}
              t={t}
            />
            {showRelatedCategories && relatedCategories?.length >= 1 && (
              <div className="mt-10">
                <Typography
                  fontVariant="h6"
                  as="h4"
                  textAlign="left"
                  className="mb-2"
                >
                  {t('common.relatedCategoriesTo', { category: categoryName })}
                </Typography>
                {relatedCategories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={cat.url || ''}
                    disabled={!cat.url}
                    className={cx(
                      'block global-hover py-2 text-clamp-h8 font-medium',
                      {
                        '!text-primary-700': !!cat.url,
                        'pointer-events-none !text-customGray-500': !cat.url,
                      }
                    )}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            )}
            {showSubCategories && subCategories?.length >= 1 && (
              <div className="mt-10">
                <Typography
                  fontVariant="h6"
                  as="h4"
                  textAlign="left"
                  className="mb-2"
                >
                  {t('common.subCategoriesTo', { category: categoryName })}
                </Typography>
                {subCategories.map((cat) => (
                  <Link
                    key={cat.url}
                    to={cat.url || ''}
                    className="block global-hover py-2 text-clamp-h8 font-medium !text-primary-700"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            )}
          </Stack>
        )}
        <Stack className="flex-1 gap-0 justify-start">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-1 w-full h-auto max-md:py-6">
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <button
                type="button"
                className={`${
                  !filter && 'hidden'
                } md:hidden bg-white shadow-xl flex flex-row global-hover border border-customGray-300 px-6 h-12 justify-center items-center gap-1 rounded-[40px]`}
                onClick={() => setIsFilterModalOpen(true)}
              >
                <Filter />
                <Typography fontVariant="h8">
                  {t('catFilter.quickGuide')}
                </Typography>
              </button>
              {systems?.length > 0 && (
                <Typography fontVariant="h6" as="h2">
                  {type == 'INDUSTRY'
                    ? t('category.listfor', {
                        number: systems?.length,
                        category: categoryName,
                      })
                    : t('category.listof', {
                        number: systems?.length,
                        category: categoryName,
                      })}
                </Typography>
              )}
            </div>
            {filter && (
              <SortDropdown
                selectedSort={sorting}
                onSelectSort={handleSortChange}
                t={t}
              />
            )}
          </div>
          {noResults && Object.keys(activeFilters).length > 0 && (
            <Stack className="w-full justify-center p-10">
              <Typography fontVariant="h6" as="h6">
                {t('category.noResults.title')}
              </Typography>
              <Typography fontVariant="p" as="p">
                {t('category.noResults.text')}
              </Typography>
            </Stack>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {systemList?.map((item) => {
              if (item.type === 'CTA') {
                return (
                  <div
                    key={item.id}
                    className="col-span-1 md:col-span-2 lg:col-span-3"
                  >
                    <SystemListCta
                      key={item.id}
                      data={item.data}
                      dark
                      classNames=""
                    />
                  </div>
                );
              }

              return (
                <SystemCard
                  key={item.id}
                  type={type}
                  data={item}
                  systemPageUrl={systemPageUrl}
                  compareSystems={compare}
                  onSystemCompare={handleCompare}
                  showCompareBtn={showCompareBtn}
                  category={category}
                  locale={locale}
                  trackOutboundLink={trackOutboundLink}
                  t={t}
                />
              );
            })}
          </div>
          {/* <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          /> */}
        </Stack>
      </div>
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center px-6 bg-black bg-opacity-70 transition-opacity duration-300 ${
          isFilterModalOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={handleBackdropClick}
      >
        {filter && (
          <FiltersModal
            handleCloseModal={() => setIsFilterModalOpen(false)}
            filters={filters}
            selectedFilters={activeFilters}
            onFilterChange={handleFilterChange}
            handleClearFilters={emptyFilter}
            category={category}
            sortFunction={sortItemsFunction}
            labelFunction={labelFunction}
            t={t}
          />
        )}
      </div>
      {showCompareBtn && (
        <CompareBottomBar
          compareSystems={compare}
          categoryId={categoryId}
          // compareSystemsPageUrl={compareSystemsPageUrl}
          compareSystemsStaticPageUrl={compareSystemsStaticPageUrl}
          onSystemCompare={handleCompare}
          onCompareClick={handleAddComparison}
          t={t}
        />
      )}
    </div>
  );
};
